var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-light btn-sm font-weight-bolder btn-upper btn-text",on:{"click":function($event){return _vm.$emit('button-clicked')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }